import { useEffect } from "react";


export default function RedirectOutilsPro() {
  useEffect(() => {
    setTimeout(() => {
      window.location.href = "https://affinicar-pro.com/savs";
    }, 0);
  }, []);
  return null;
}